/**
 * The main api service
 */
import http from "@util/http";
import { finance } from "../req";

/**
 * 分摊
 */
export async function queryApportionOrigin(params) {
  return http.get(finance.GET_APPORTION_ORIGIN, params);
}

export async function queryApportionList(params) {
  return http.get(finance.GET_APPORTION_LIST, params);
}

export async function queryApportionInfo(params) {
  return http.get(finance.GET_APPORTION_INFO, params);
}

export async function querySaveApportion(params) {
  return http.post(finance.SAVE_APPORTION, params);
}

export async function querySaveApportionDetail(uuid, params) {
  return http.post(`${finance.SAVE_APPORTION_DETAIL}/${uuid}`, params);
}

export async function queryDeleteApportionDetail(params) {
  return http.post(finance.APPORTION_DELETE_DETAIL, params);
}

export async function queryCheckApportionDetail(params) {
  return http.get(finance.APPORTION_CHECK_DETAIL, params);
}

export async function queryApportionIsPublic(params) {
  return http.get(finance.APPORTION_ISPUBLIC, params);
}

export async function queryDeleteApportion(params) {
  return http.get(finance.APPORTION_DELETE, params);
}

export async function queryApportionToNo(params) {
  return http.get(finance.APPORTION_TONO, params);
}

export async function queryApportionToRestore(params) {
  return http.get(finance.APPORTION_TORESTORE, params);
}



// WEBPACK FOOTER //
// ./src/api/finance/apportion.js